module.exports = __webpack_public_path__ + "img/advantage3_1@2x.4309c79d.png";